import React from 'react';
import styles from '../../styles/loading.module.css';

const Loading = ({ message = 'Cargando...' }) => {
  return (
    <div className={styles.container}>
      <div className={styles.spinner}></div>
      <p>{message}</p>
    </div>
  );
};

export default Loading;